import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { NoteDb } from '../redux/noteDbSlice';
import useCurrentUserId from './useCurrentUserId';

const useNoteDbByReference = (referenceId?: string): [string | undefined, NoteDb | undefined] => {
  const userId = useCurrentUserId();
  const notes = useSelector((state: RootState) => state.noteDb.notes);
  if (!userId || !referenceId) return [undefined, undefined];
  const id = Object.keys(notes).find(id => notes[id].userId === userId && notes[id].referenceId === referenceId);
  if (!id) return [undefined, undefined];
  const value = notes[id];

  return [id, value];
}

export default useNoteDbByReference;
